import { useMfaPreferenceQuery } from 'features/data/amplify/useMfaPreferenceQuery';
import { createContext, useContext } from 'react';
import { CurrentUserQuery, useCurrentUserQuery } from 'features/data/amplify/useCurrentUserQuery';

type AuthContext = {
	mfaPreferenceQuery: ReturnType<typeof useMfaPreferenceQuery>;
	currentUserQuery: CurrentUserQuery;

	forceRefreshTokens: () => Promise<void>;
};

export const AuthContext = createContext<AuthContext | null>(null);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
	const currentUserQuery = useCurrentUserQuery();
	const mfaPreferenceQuery = useMfaPreferenceQuery(currentUserQuery.data?.username);

	// In the iframe context, token refresh is handled by the shell.
	// This is a no-op to keep the interface compatible.
	const forceRefreshTokens = async () => {
		// Shell handles Cognito session refresh via on-activity pings
	};

	return (
		<AuthContext.Provider value={{ mfaPreferenceQuery, currentUserQuery, forceRefreshTokens }}>
			{children}
		</AuthContext.Provider>
	);
};

export const useAuth = () => {
	const context = useContext(AuthContext);
	if (!context) {
		throw new Error('useAuth must be used within an AuthProvider');
	}
	return context;
};
